import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { Box, Button, ButtonState, Group, GroupAlign, Popover, PopoverType, Text, usePopoverHandlers, } from '@as/cotopaxi';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EventEnum } from '@as-react/common-types';
import { EventUtil } from '@as-react/common-utils';
import { useAemConfig } from '@as-react/common-components';
import { useDispatch } from 'react-redux';
import sessionActions from '../../redux/session/actions/SessionActions.creators';
import { useOAuth } from '../../hooks/useOAuth';
import { useFeatureToggle } from '../../hooks/useFeatureToggle';
export const SecurityLevelsPopup = () => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const isMobile = useMediaQueryMatchesOnMobile();
    const { root } = useAemConfig();
    const dispatch = useDispatch();
    const [buttonState, setButtonState] = useState(ButtonState.INTERACTIVE);
    const { authUrl, logout } = useOAuth();
    const isNewAuth = useFeatureToggle('use_new_auth_flow');
    const handlePopoverLogout = () => {
        setButtonState(ButtonState.LOADING);
        isNewAuth ? logout() : dispatch(sessionActions.createLogoutAction());
        window.location.href = isNewAuth ? authUrl : `${root}account.html`;
    };
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers();
    const handleShowSecurityLevelsPopup = () => handlePopoverOpen(null, null, true);
    useEffect(() => {
        EventUtil.listen(EventEnum.USER_SECURITY_LEVEL_TOO_LOW, handleShowSecurityLevelsPopup);
        return () => EventUtil.remove(EventEnum.USER_SECURITY_LEVEL_TOO_LOW, handleShowSecurityLevelsPopup);
    }, []);
    return (_jsx(Popover, { anchorEl: anchorEl, type: PopoverType.MODAL, onClose: handlePopoverClose, noFooterShadow: true, footerElement: _jsx(Box, { tablet: { spacing: { marginLeft: 2, marginRight: 2, marginBottom: 2 } }, children: _jsx(Group, { align: GroupAlign.RIGHT, children: _jsx(Button, { fill: isMobile, text: t('account.security.levels.popup.button'), onClick: handlePopoverLogout, state: buttonState }) }) }), dataQA: "security_level_popup", children: _jsx(Box, { mobile: { spacing: { marginTop: 0, marginBottom: 1, marginLeft: 2, marginRight: 2 } }, tablet: { spacing: { marginBottom: 2, marginLeft: 4, marginRight: 4 } }, children: _jsx(Text, { children: t('account.security.levels.popup.info') }) }) }));
};
